import {
  faDeleteLeft,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Divider, Row, Space, Typography } from "antd";
import { Button, Container, FieldInfo, InfoLanguage } from "components/ui";
import { useState } from "react";
import { Link } from "react-router-dom";
import useAchievementsInfoContext from "../services/achievementsInfoContext";

const AchievementsInfo = () => {
  const [lang, setLang] = useState<"uz" | "en" | "ru">("uz");
  const {
    state: { data, loading },
    actions: { handleDelete },
  } = useAchievementsInfoContext();

  return (
    <Row gutter={[20, 20]}>
      <Col xs={24} md={19}>
        <Container loading={loading}>
          <div>
            <Typography.Title level={4}>Ma'lumot</Typography.Title>
            <Divider />
            <Row gutter={[20, 20]}>
              <Col xs={24}>
                <FieldInfo
                  title="Natija rasmi"
                  value={data?.image_url}
                  type="image"
                  style={{ height: 400 }}
                />
              </Col>
              <Col xs={24}>
                <FieldInfo
                  title="Student ismi"
                  value={data?.student_name}
                  type="text"
                />
              </Col>
              <Col xs={24}>
                <FieldInfo
                  title="Izohi"
                  value={data?.comment[lang]}
                  type="text"
                  html
                />
              </Col>
            </Row>
          </div>
        </Container>
      </Col>
      <Col xs={24} md={5}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <InfoLanguage onClick={(lang) => setLang(lang)} />
          <Link to={`/achievements/create/${data?._id}`}>
            <Button
              icon={<FontAwesomeIcon icon={faEdit} />}
              block
              type="primary"
              style={{ backgroundColor: "orange" }}
            >
              O'zgartirish
            </Button>
          </Link>
          <Button
            icon={<FontAwesomeIcon icon={faTrash} />}
            block
            type="primary"
            onClick={handleDelete}
          >
            O'chirish
          </Button>
        </Space>
      </Col>
    </Row>
  );
};

export default AchievementsInfo;
